import { createContext } from "react";
import {
  DEFAULT_GUIDES_QUESTIONS,
  DEFAULT_SUMMARY_CONTENT,
  QuestionInterface,
} from "../constants/questions";

const GuideQuestionsContext = createContext<{
  questions: { data: QuestionInterface[] };
  summaryContent: { data: any };
  setQuestions(questions: { data: QuestionInterface[] }): any;
  setSummaryContent(summaryContent: { data: any }): any;
}>({
  questions: DEFAULT_GUIDES_QUESTIONS,
  summaryContent: DEFAULT_SUMMARY_CONTENT,
  setQuestions: (questions) => {},
  setSummaryContent: (summaryContent) => {},
});

export default GuideQuestionsContext;
